module.exports = __webpack_public_path__ + "img/union-pacific.10bd69eb.png";